
































































































































import Vue from 'vue';
import Inputs from '@/components/Inputs.vue';
import Checkout from '@/components/Checkout.vue';
import RandomQuestions from '@/components/RandomQuestions.vue';

export default Vue.extend({
  name: 'Home',

  components: {
    Inputs,
    Checkout,
    RandomQuestions,
  },

  data: () => ({
    //
  }),

  computed: {
    queryCount(): number {
      return this.$store.getters.queryCount;
    },
  },

  methods: {

  },

});
